import React, { useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './MobileTopNav.scss';
import { IconChevronDown, IconKS } from 'components/Icons';
import { useAuthContext } from 'context/useAuthContext';
import MobileActionModal, { MobileActionOption } from '../MobileActionModal/MobileActionModal';

type Props = {
  locationName: string;
  userName: string;
  onLocationClick: () => void;
  activeTab: 'home' | 'requests' | 'kai';
  onTabChange: (tab: 'home' | 'requests' | 'kai') => void;
};

function MobileTopNav({ locationName, userName, onLocationClick, activeTab, onTabChange }: Props): JSX.Element {
  const initials = userName
    .split(' ')
    .map(name => name[0])
    .join('');
  const auth = useAuthContext();

  const [isActionModalOpen, setIsActionModalOpen] = useState(false);

  const handleSignOut = async () => {
    await auth.signOut();
    localStorage.removeItem('recentLocations');
    setIsActionModalOpen(false); // Close modal after sign out
  };

  const handleToggleActionModal = () => {
    setIsActionModalOpen(!isActionModalOpen);
  };

  const handleCloseActionModal = () => {
    setIsActionModalOpen(false);
  };

  // Define options for the modal
  const modalOptions: MobileActionOption[] = [
    { name: 'Sign Out', onClick: handleSignOut },
    // Add other options here later if needed
  ];

  const avatarRef = useRef<HTMLDivElement>(null);

  return (
    <div className="MobileTopNav">
      <div className="MobileTopNav-header">
        <div className="MobileTopNav-logo">
          <IconKS />
        </div>
        <div className="MobileTopNav-info">
          <div className="MobileTopNav-location" onClick={onLocationClick}>
            <span className="MobileTopNav-locationName">{locationName}</span>
            <span className="MobileTopNav-locationArrow">
              <IconChevronDown />
            </span>
          </div>
          <div ref={avatarRef} className="MobileTopNav-avatar" onClick={handleToggleActionModal}>
            <div className="MobileTopNav-avatarCircle">{initials}</div>
          </div>
        </div>
      </div>
      <MobileActionModal
        isOpen={isActionModalOpen}
        onClose={handleCloseActionModal}
        options={modalOptions}
        triggerRef={avatarRef}
        align="right"
        // title="Account Actions" // Optional title
      />
    </div>
  );
}

export default MobileTopNav;
